<template>
   <div class="year-selection">
      <div class="year-selection-row">
         <h1 class="current-period">{{ periodLabel }}</h1>
         <div class="periods-button-wrapper" v-if="previousPeriodId || nextPeriodId">
            <b-button
               id="btn-prev-year"
               :disabled="!previousPeriodId"
               variant="outline-primary"
               class="d-flex align-items-center no-wrap action-button previous-period-button"
               @click="toPreviousPeriod"
            >
               Previous
            </b-button>
            <b-button
               id="btn-next-year"
               :disabled="!nextPeriodId"
               variant="outline-primary"
               class="d-flex align-items-center no-wrap action-button next-period-button"
               @click="toNextPeriod"
            >
               Next
            </b-button>
         </div>
      </div>
   </div>
</template>

<script>
import {mapGetters} from 'vuex';

export default {
   props: {
      expenseType: {
         type: String,
         required: true,
         validator: (value) => ['cloud', 'supplies', 'contractors', 'employees'].includes(value),
      },
   },
   computed: {
      ...mapGetters({
         profile: 'profile',
         isSME: 'isSME',
         studyPeriodMap: 'companies/studyPeriodMap',
         activeStudyId: 'companies/activeStudyId',
      }),

      manualVendors() {
         return this.$store.getters[`${this.expenseType}/manualVendors`];
      },
      importedVendors() {
         return this.$store.getters[`${this.expenseType}/importedVendors`];
      },
      periodId() {
         return this.$route.params.periodId;
      },
      periodLabel() {
         return this.studyPeriodMap[this.periodId].label;
      },
      periodIds() {
         return this.$store.getters[`${this.expenseType}/supportedPeriodIds`];
      },
      periodMap() {
         return this.periodIds.map((periodId) => this.studyPeriodMap[periodId]);
      },
      hasManualVendors() {
         return Object.values(this.manualVendors).length;
      },
      currentPeriodIndex() {
         return this.periodMap.findIndex(({id}) => Number(id) === Number(this.periodId));
      },
      previousPeriod() {
         if (this.currentPeriodIndex <= 0) return {};

         const prev = this.periodMap[this.currentPeriodIndex - 1];

         if (this.isSME) return this.hasAssignedVendorsForPeriod(prev) ? prev : {};

         return this.hasVendorsForPeriod(prev) ? prev : {};
      },
      previousPeriodId() {
         return this.previousPeriod.id;
      },
      nextPeriod() {
         const next = this.periodMap[this.currentPeriodIndex + 1];
         if (!next) return {};

         if (this.isSME) return this.hasAssignedVendorsForPeriod(next) ? next : {};

         return this.hasVendorsForPeriod(next) ? next : {};
      },
      nextPeriodId() {
         return this.nextPeriod.id;
      },
   },

   methods: {
      getImportedVendorsBy({lower, upper}) {
         return this.importedVendors.filter(
            ({period}) => period.lower === lower && period.upper === upper
         );
      },

      hasAssignedVendorsForPeriod({period}) {
         return [...this.getImportedVendorsBy(period), ...Object.values(this.manualVendors)].some(
            ({assigneeId}) => this.profile.id === assigneeId
         );
      },

      hasVendorsForPeriod({period}) {
         if (this.hasManualVendors) return true;
         return !!this.getImportedVendorsBy(period).length;
      },

      toNextPeriod() {
         this.$router.push({
            name: this.$route.name,
            params: {periodId: this.nextPeriodId},
         });
      },

      toPreviousPeriod() {
         this.$router.push({
            name: this.$route.name,
            params: {periodId: this.previousPeriodId},
         });
      },
   },
};
</script>

<style scoped lang="scss">
.year-selection {
   margin-bottom: 2rem;

   &-row {
      display: flex;
      justify-content: space-between;
      align-items: center;

      .current-period {
         color: inherit;
         font-size: 1.25rem;
      }

      .periods-button-wrapper {
         display: flex;
         justify-content: space-between;
         align-items: center;
         gap: 0.625rem;
      }

      .year-nav-btn button {
         border: 0;
         background-color: transparent;
         color: $secondary;
         transition: all 0.2s ease;

         &:hover {
            color: $primary;
            text-decoration: underline;
         }

         svg {
            margin-bottom: 0.6em;
         }
      }
   }
}
.card-description {
   font-size: 12px;
}
.assignments-card {
   box-shadow: 0 4px 20px 0 #005d8b26 !important;
   width: 100%;
}

.status-class {
   font-size: 16px;
}

.action-button {
   font-size: 0.75rem;
}

.previous-period-button {
   &:disabled {
      background-color: white;
      color: gray;
   }
}

.next-period-button {
   &:disabled {
      background-color: white;
      color: gray;
   }
}
</style>
